import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * True when the browser history holds an earlier screen of this app.
 * React Router keeps the entry index in `history.state.idx`; 0 means the card
 * was opened directly (new tab, pasted link, reload of the first entry).
 */
export function hasInAppHistory(): boolean {
  const idx = (window.history.state as { idx?: unknown } | null)?.idx;
  return typeof idx === 'number' && idx > 0;
}

/**
 * The single rule for every in-app „Wstecz” button: go back to the screen the
 * user opened before this one, exactly like the browser back button. The
 * `fallback` (usually the list of this card's type) is used only when there is
 * no earlier in-app screen.
 *
 * Keep in-card view switches (edit mode, tabs) as `replace` navigations so
 * „Wstecz” leaves the card instead of stepping through its internal states.
 */
export function useBackNavigation(): (fallback: string) => void {
  const navigate = useNavigate();
  return useCallback((fallback: string) => {
    if (hasInAppHistory()) navigate(-1);
    else navigate(fallback);
  }, [navigate]);
}
